/*
 * Created on Tue Jul 30 2019
 * Author: Val Liu
 * Copyright (c) 2019
 */

import Server from "@/config/default/server";
import { VueHolder } from "@root/core/utilities";
import { throttleTime } from "rxjs/operators";
import router from "@root/core/router";
import Vue from "vue";
import AlertResponse from "@root/components/modals/utilities/alert-response/alert-response.vue";

/// auto alert message, while http request fail

let ins: Vue;
let handling401 = false;

const showUnauthorizedAlert = async () => {
    if (handling401) return;
    handling401 = true;
    if (ins == undefined) ins = VueHolder();
    const message = ins.$_("w_Status401_Message", [401]);
    const modal = new AlertResponse({
        propsData: {
            label: "w_Status401",
            value: message,
            data: {
                "text-submit": "w_ReLogin",
            },
        },
    });
    modal.$on("submit", async () => {
        await ins.$logout();
        (await router).push("//");
    });
    modal.$on("update:visible", (visible: boolean) => {
        if (!visible) handling401 = false;
    });
    modal.$modal();
};

Server.getDefault()
    .sjUnauthorized.pipe(throttleTime(0))
    .subscribe(async () => {
        await showUnauthorizedAlert();
    });

Server.getDefault()
    .sjError.pipe(throttleTime(0)) /// to prevent too many errors
    .subscribe(async (e) => {
        if ((e as any)?.error?.handled) return;
        /// if silent, don't show alert message.
        if (e.silent == true) return;
        /// lazy initial
        if (ins == undefined) ins = VueHolder();

        /// Network Error: with error.err, no error.res
        /// Bad Request (400): "The request could not be processed due to invalid input. Please check your data and try again."
        /// 404 Not Found: "The requested resource was not found. Please check the URL and try again."
        /// 403 Forbidden: "You do not have permission to access this resource."
        /// 401 Unauthorized: "You are not authorized. Please log in and try again."
        /// 500 Internal Server Error: "A server error occurred. We're working to fix this issue. Please try again later."
        const showingStatus = [400, 403, 404, 422, 500];
        let statusCode = e.error?.res?.statusCode;
        let statusName = statusCode;
        if (showingStatus.indexOf(statusCode) < 0) {
            statusCode = "Unknown";
            statusName = ins.$_(`w_${statusCode}`);
        }

        ins.$alert(
            {
                title: `${e.uri}
        <span class="text-danger" style="font-size: 1.1rem">
        (${e.method}, ${statusName})
        </span>`,
                message: ins.$_(`w_Status${statusCode}_Message`, [statusCode]),
            },
            "warning",
        );
    });
